import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import { ListTable } from '../../molecules/ListTable';
import { IBooking } from '../../../utils/entities/interface';
import {
  capitalizeWords,
  formatPhoneNumber,
  getStatusLabel,
} from '../../../utils/helper';
import { ServiceTypesCell } from './ServiceTypesCell';

export const CancelledList = ({
  bookings,
  isLoading,
  onManageClick,
  onlyview,
  headerCells,
}: {
  bookings: IBooking[];
  isLoading: boolean;
  onManageClick: (id: string) => void;
  onlyview?: boolean;
  headerCells: [string, number][];
}) => {
  const actions = [
    {
      icon: <RemoveRedEyeOutlinedIcon />,
      onClick: (row: IBooking) => onManageClick(row._id),
    },
    // !onlyview && {
    //   icon: <BorderColorOutlinedIcon />,
    //   onClick: (row: IBooking) =>
    //     window.open(`/bookings/edit/${row._id}`, '_self'),
    // },
    // !onlyview && {
    //   icon: <EngineeringOutlinedIcon />,
    //   onClick: (row: IBooking) =>
    //     window.open(`/bookings/assign/${row._id}`, '_self'),
    // },
  ].filter(Boolean) as any[];

  return (
    <ListTable
      headerCells={headerCells}
      rows={bookings}
      isLoading={isLoading}
      actions={actions}
      renderCell={(booking: IBooking, colIndex: number) => {
        switch (colIndex) {
          case 0:
            return booking.bookingId || '-';
          case 1:
            return capitalizeWords(booking.user.name) || 'N/A';
          case 2:
            return <ServiceTypesCell booking={booking} />;
          case 3:
            return formatPhoneNumber(booking.user.phoneNumber);
          case 4:
            return booking?.cancelReason || 'N/A';
          case 5:
            return getStatusLabel(booking.status);
          default:
            return null;
        }
      }}
    />
  );
};
